import EncryptionContext from "config/context/encryptionContext";
import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useState } from "react";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useSetEncryptionKey = ({ encryption_key }) => {
    const [response, setResponse] = useState(initialServerStatus.response);
    const [loading, setLoading] = useState(initialServerStatus.loading);
    const [error, setError] = useState(initialServerStatus.error);
    const { updateEncryptionStatus } = useContext(EncryptionContext);

    const {
        selected: { selectedAccount },
        URL,
    } = useContext(GuiContext);


    const setEncryptionKey = async () => {

        // if (!testPrivateKey(privateKey)) {
        //     setError('Invalid private key!');
        //     return;
        // }

        setError(null);

        setLoading(true);

        try {
            const res = await fetch(`${URL}/api/plugins/set_encryption_key`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount,
                    encryption_key: encryption_key
                }),
            });

            const data = await res.json();
            updateEncryptionStatus(true, data?.expiration);
            resetServerStatus();
            setResponse(data);
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    const resetServerStatus = useCallback(() => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }, [])

    return {
        response,
        loading,
        error,
        setEncryptionKey,
        resetServerStatus
    };
}